import React, { Component } from "react";
import "./success-message-component.css";
import Icons from "../../icon";
import Translation from "../../common/translation/translation.component";
export class SuccessMessage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div className="success-message-container">
                <div className="success-message-wrapper">
                    <Icons
                    name="check-circle-duo"
                    size="31px"
                    customClassName="icon-check-circle-duo"               
                    />
                    <h1 className="success-title">
                        {/*{this.props.message}*/}
                        <Translation translationKey="success_modal_content" />
                    </h1>
                     <Icons
                    name="circle-times"
                    size="20px"
                    customClassName="icon-circle-times"               
                    />
                </div>              
            </div>
        );
    }
}

export class FailMessage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="danger-message-container">
                <div className="danger-message-wrapper">
                    <Icons
                        name="circle-close-duo"
                        size="31px"
                        customClassName="icon-check-circle-duo"
                    />
                    <h1 className="danger-title">{this.props.message}</h1>
                    <Icons
                        name="circle-times"
                        size="20px"
                        customClassName="icon-circle-times"
                    />
                </div>
            </div>
        );
    }
}